// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-wrap {
  font-family: var(--font-family);
}
.product-detail-wrap .product-img-slider-wrap {
  padding: 80px 60px 10px 60px;
  background: #F8F8F8;
  margin-top: 10px;
}
.product-detail-wrap .product-request-btn-wrap {
  color: #3E7028;
  text-align: right;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-detail-wrap .product-request-btn-wrap button {
  color: #3E7028;
  text-align: right;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}
.product-detail-wrap .previous-requested-price {
  text-align: center;
  padding-bottom: 2px;
}
.product-detail-wrap .product-request-msg {
  color: #4C5258;
  text-align: right;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
}
.product-detail-wrap .product-title {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding-bottom: 4px;
}
.product-detail-wrap .product-img {
  display: block;
  margin: auto;
  padding: 75px 0px 80px;
  max-width: 270px;
  width: 100%;
}
.product-detail-wrap .product-img img {
  width: 100%;
  object-fit: contain;
}
.product-detail-wrap swiper-container::part(bullet-active) {
  background-color: #6ECB44;
}
.product-detail-wrap swiper-container::part(button-next) {
  color: #6ECB44;
  height: 27px;
  width: 14px;
  top: calc(50% - 15px);
}
.product-detail-wrap swiper-container::part(button-prev) {
  color: #6ECB44;
  height: 27px;
  width: 14px;
  top: calc(50% - 15px);
}
.product-detail-wrap swiper-container::part(pagination) {
  margin-bottom: -50px;
  position: relative;
}
.product-detail-body-wrap {
  padding-top: 50px;
}
.product-detail-body-wrap .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: none;
}
.product-detail-body-wrap .mat-expansion-panel:not([class*=mat-elevation-z]) {
  background: inherit;
  box-shadow: none;
}
.product-detail-body-wrap .mat-expansion-panel-header {
  padding: 0;
}
.product-detail-body-wrap .expansion-panel-grp {
  border-block: 1px solid #DCDCDC;
  margin-block: 28px 20px;
  padding-block: 15px;
}
.product-detail-body-wrap .summary {
  font-family: var(--font-family);
  color: #252525;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.product-detail-body-wrap .detail {
  color: #252525;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 22px;
  font-family: var(--font-family);
}
.product-detail-body-wrap .product-sku {
  color: #252525;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 15px;
  padding-bottom: 15px;
}
.product-detail-body-wrap .product-btn-group {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 80px;
}
.product-detail-body-wrap .sell-product-btn {
  border-radius: 60px;
  background: #6ECB44;
  width: 166px;
  padding: 13px 24px;
  color: #FFF;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
}
.product-detail-body-wrap .price-change-request {
  border-radius: 60px;
  background: #fff;
  width: 190px;
  padding: 13px 24px;
  color: #6ECB44;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  border: 1px solid #6ECB44;
}

@media (max-width: 767px) {
  .product-detail-wrap .product-img-slider-wrap {
    padding-inline: 20px;
    padding-top: 45px;
  }
  .product-detail-wrap .product-img {
    padding: 55px 60px 80px;
  }
}
@media (max-width: 492px) {
  .product-detail-body-wrap .product-btn-group {
    flex-direction: column;
  }
  .product-detail-body-wrap .product-btn-group button {
    width: 100%;
    margin-bottom: 20px;
  }
  .product-detail-wrap .product-img-slider-wrap {
    padding-inline: 10px;
    padding-top: 45px;
  }
  .product-detail-wrap .product-img {
    padding: 55px 60px 80px;
    max-width: 270px;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/products/product-detail/product-detail.component.scss"],"names":[],"mappings":"AACI;EACI,+BAAA;AAAR;AACQ;EACI,4BAAA;EACA,mBAAA;EACA,gBAAA;AACZ;AACQ;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACZ;AAAY;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEhB;AACQ;EACI,kBAAA;EACA,mBAAA;AACZ;AACQ;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACZ;AACQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACZ;AACQ;EACI,cAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AACZ;AAAY;EACI,WAAA;EACA,mBAAA;AAEhB;AACQ;EACI,yBAAA;AACZ;AACQ;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AACZ;AACQ;EACI,cAAA;EACA,YAAA;EACC,WAAA;EACA,qBAAA;AACb;AACQ;EACI,oBAAA;EACA,kBAAA;AACZ;AAKI;EACI,iBAAA;AAHR;AAKQ;EACI,gBAAA;AAHZ;AAKQ;EACI,mBAAA;EACA,gBAAA;AAHZ;AAKQ;EACI,UAAA;AAHZ;AAKQ;EACI,+BAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,+BAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAHZ;AAKQ;EACI,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAHZ;AAKQ;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHZ;AAKQ;EACI,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAHZ;;AAOA;EAGY;IACI,oBAAA;IACA,iBAAA;EANd;EAQU;IACI,uBAAA;EANd;AACF;AAcA;EAGY;IACI,sBAAA;EAdd;EAec;IACI,WAAA;IACA,mBAAA;EAblB;EAkBU;IACI,oBAAA;IACA,iBAAA;EAhBd;EAkBU;IACI,uBAAA;IACA,gBAAA;IACA,WAAA;EAhBd;AACF","sourcesContent":[".product-detail{\n    &-wrap{\n        font-family:  var(--font-family);\n        .product-img-slider-wrap {\n            padding: 80px 60px 10px 60px;\n            background: #F8F8F8;\n            margin-top: 10px;\n        }\n        .product-request-btn-wrap {\n            color: #3E7028;\n            text-align: right;\n            font-family:  var(--font-family);\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px;\n            padding-top: 2px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            button{\n                color: #3E7028;\n                text-align: right;\n                font-family:  var(--font-family);\n                font-size: 11px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 14px;\n            }\n        }\n        .previous-requested-price {\n            text-align: center;\n            padding-bottom: 2px;\n        }\n        .product-request-msg {\n            color: #4C5258;\n            text-align: right;\n            font-family:  var(--font-family);\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px;\n            text-align: center;\n        }\n        .product-title {\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n            padding-bottom: 4px;\n        }\n        .product-img {\n            display: block;\n            margin: auto;\n            padding: 75px 0px 80px;\n            max-width: 270px;\n            width: 100%;\n            img{\n                width: 100%;\n                object-fit: contain;\n            }\n        }\n        swiper-container::part(bullet-active) {\n            background-color: #6ECB44;\n        }\n        swiper-container::part(button-next){\n            color: #6ECB44;\n            height: 27px;\n            width: 14px;\n            top: calc(50% - 15px);\n        }\n        swiper-container::part(button-prev){\n            color: #6ECB44;\n            height: 27px;\n             width: 14px;\n             top: calc(50% - 15px);\n        }\n        swiper-container::part(pagination){\n            margin-bottom: -50px;\n            position: relative;\n         }\n        \n      \n     \n    }\n    &-body-wrap {\n        padding-top: 50px;\n       \n        .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]){\n            background: none;\n        }\n        .mat-expansion-panel:not([class*=mat-elevation-z]){\n            background: inherit;\n            box-shadow: none;\n        }\n        .mat-expansion-panel-header{\n            padding: 0;\n        }\n        .expansion-panel-grp {\n            border-block: 1px solid #DCDCDC;\n            margin-block: 28px 20px;\n            padding-block: 15px\n        }\n        .summary {\n            font-family:  var(--font-family);\n            color: #252525;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n        }\n        .detail {\n            color: #252525;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 300;\n            line-height: 22px;\n            font-family:  var(--font-family);\n        }\n        .product-sku {\n            color: #252525;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 300;\n            line-height: 15px;\n            padding-bottom: 15px;\n        }\n        .product-btn-group {\n            display: flex;\n            justify-content: center;\n            gap: 20px;\n            margin-bottom: 80px;\n        }\n        .sell-product-btn {\n            border-radius: 60px;\n            background: #6ECB44;\n            width: 166px;\n            padding: 13px 24px;\n            color: #FFF;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 14px;\n        }\n        .price-change-request{\n            border-radius: 60px;\n            background: #fff;\n            width: 190px;\n            padding: 13px 24px;\n            color: #6ECB44;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 14px;\n            border: 1px solid #6ECB44;\n        }\n    }\n}\n@media (max-width: 767px) {\n    .product-detail{\n        &-wrap{\n            .product-img-slider-wrap{\n                padding-inline: 20px;\n                padding-top: 45px;\n            }\n            .product-img{\n                padding: 55px 60px 80px;\n              \n            }\n        }\n    }\n\n}\n\n\n@media (max-width: 492px) {\n    .product-detail{\n        &-body-wrap {\n            .product-btn-group {\n                flex-direction: column;\n                button{\n                    width: 100%;\n                    margin-bottom: 20px;\n                }\n            }\n        }\n        &-wrap{\n            .product-img-slider-wrap{\n                padding-inline: 10px;\n                padding-top: 45px;\n            }\n            .product-img{\n                padding: 55px 60px 80px;\n                max-width: 270px;\n                width: 100%;\n            }\n        }\n    }\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
